import React from 'react';
import { Alert, Snackbar, useTheme } from '@mui/material';
import { useSnackbarStore } from 'store/use-combine-store';

export default function CustomSnackbar() {
  const theme = useTheme();
  const { snackbar, closeSnackbar } = useSnackbarStore();

  const getAlertStyles = (severity) => {
    const colors = {
      error: theme.palette.error[50],
      success: theme.palette.success[50],
      warning: theme.palette.warning[50]
    };
    const iconColors = {
      error: theme.palette.error[400],
      success: theme.palette.success[400],
      warning: theme.palette.warning[400]
    };
    return {
      iconColor: iconColors[severity],
      backgroundColor: colors[severity]
    };
  };

  const { backgroundColor, iconColor } = getAlertStyles(snackbar.severity);

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={5000}
      onClose={closeSnackbar}
      sx={{ width: '100%', maxWidth: 550 }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity={snackbar.severity}
        sx={{
          p: 1.5,
          fontSize: 12,
          width: '100%',
          borderRadius: 2,
          fontWeight: 500,
          backgroundColor,
          fontFamily: 'Manrope',
          color: theme.palette.grey[800],
          '& .MuiAlert-icon': {
            p: 0,
            mr: 1,
            fontSize: 18,
            color: iconColor
          },
          '& .MuiAlert-message': { p: 0 }
        }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}
